<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.slider.tanimlama.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="sliderForm" :rules="rulesSlider" ref="sliderForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.slider.tanimlama.anaBaslik")'
                                              prop="anaBaslik">:
                                    <el-input
                                            v-model="sliderForm.anaBaslik"
                                            :placeholder='$t("src.views.apps.slider.tanimlama.anaBaslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.slider.tanimlama.altBaslik")'
                                              prop="altBaslik">:
                                    <el-input
                                            v-model="sliderForm.altBaslik"
                                            :placeholder='$t("src.views.apps.slider.tanimlama.altBaslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.slider.tanimlama.aciklama")'
                                              prop="aciklama">:
                                    <el-input
                                            type="textarea"
                                            v-model="sliderForm.aciklama"
                                            :placeholder='$t("src.views.apps.slider.tanimlama.aciklamaPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                              prop="resim">:
                                    <el-upload
                                            class="resimler"
                                            action=""
                                            list-type="picture-card"
                                            multiple
                                            :limit="1"
                                            :file-list="imageListMain"
                                            :auto-upload="false"
                                            accept=".jpg,.jpeg,.png"
                                            :on-change="imageUpload"
                                            :on-remove="imageRemove">
                                        <i slot="default" class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-button size="mini" class="margin-bottom-10" type="primary" v-on:click="sliderBg">Slider Background</el-button>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item>
                                    <el-checkbox v-model="checked">Slider'da Link Olsun Mu?</el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-collapse v-if="checked" style="margin-top: 10px" v-model="activeCollapse">
                        <el-row :gutter="10">
                            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.link1Baslik")'
                                                  name="3">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="link1">:
                                                <el-input
                                                        v-model="sliderForm.link1"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="link1">:
                                                <el-input
                                                        v-model="sliderForm.linkButon1"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.link2Baslik")'
                                                  name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="link2">:
                                                <el-input
                                                        v-model="sliderForm.link2"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="link1">:
                                                <el-input
                                                        v-model="sliderForm.linkButon2"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                        </el-row>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.slider.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                v-model="sliderForm.durum"
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini" v-on:click="sliderTanimlama('sliderForm',sliderForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="sliderForm.durum === '1'">{{$t('src.views.apps.slider.tanimlama.sliderEkle')}}</label>
                                    <label v-else>Taslak Olarak Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('sliderForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.slider.tanimlama.copKutusu')" :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="sliderTanimlama('sliderForm','2')" type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.oncekiSlider")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="sliderTuru">
                                        <el-tree
                                                :data="sliderList"
                                                @node-click="handleNodeClick"
                                                node-key="sliderId"
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                    <div style="font-style: italic">* Eklenen Slider'ın hangi Slider'dan
                                        sonra gelmesini istersiniz?
                                    </div>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import WsProvider from '../../../WSProvider/provider/WSProvider'

    let $ = JQuery;
    import draggable from 'vuedraggable'
    import sliderService from '../../../WSProvider/SliderService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import functions from '../../../functions'

    let base64 = require('base64_js');
    let userDataExon = "";

    export default {
        name: "SliderTanimla",
        components: {
            draggable
        },
        data() {
            return {
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                //Tree
                visibleUstSayfa: false,
                treeList: [],
                defaultProps: {
                    label: 'anaBaslik'
                },
                // Form
                checked: false,
                visibleSil: false,
                imageListMain: [],
                fileListMain: [],
                sliderList: [],
                sliderForm: {
                    anaBaslik: "",
                    altBaslik: "",
                    aciklama: "",
                    resim: [],
                    background: "1",
                    durum: "1",
                    link1: '',
                    linkButon1: '',
                    link2: '',
                    linkButon2: '',
                    // sliderTuru: '0',
                    oncekiSliderKodu: '',
                },
                rulesSlider: {
                    anaBaslik: [{
                        required: true,
                        message: "Lütfen AnaBaşlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        mounted() {
            if (localStorage.getItem("userDataExon")) {
                userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
            }
            this.sliderListe();
        },
        methods: {
            sliderBg(){window.open(sliderService.bg, '_blank');},
            handleNodeClick(data) {
                notification.Status('success', this, data.anaBaslik + ' slider seçildi.');
                this.sliderForm.oncekiSliderKodu = data.sliderId;
            },
            sliderListe() {
                sliderService.sliderKisaList().then((response) => {
                    if (response.status === 200) {
                        this.sliderList = response.data;
                        this.sliderForm.oncekiSliderKodu = this.sliderList[parseInt(this.sliderList.length - 1)].sliderId;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                $('.el-upload--picture-card').show();
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('slider', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            imageUpload(file, fileList) {
                fileList.pop();
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.sliderForm.anaBaslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(this.sliderForm.anaBaslik) + ".jpg";
                        } else {
                            imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(this.sliderForm.anaBaslik) + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            // sliderChange(val) {
            //     this.sliderForm.background = parseInt(val + 1);
            // },
            // resimChange(val) {
            //     this.sliderForm.resim = parseInt(val + 1);
            // },
            sliderTanimlama(formName, durum) {
                let self = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.sliderForm.resim = e.name;
                        });
                        if (!this.checked) {
                            this.sliderForm.link1 = '';
                            this.sliderForm.linkButon1 = '';
                            this.sliderForm.link2 = '';
                            this.sliderForm.linkButon2 = '';
                        }
                        sliderService.sliderTanimlama(this.sliderForm.oncekiSliderKodu, this.sliderForm.resim, this.sliderForm.anaBaslik, this.sliderForm.altBaslik, this.sliderForm.aciklama, this.sliderForm.link1, this.sliderForm.linkButon1, this.sliderForm.link2, this.sliderForm.linkButon2, durum).then((response) => {
                            if (response.status === 200) {
                                switch (durum) {
                                    case '0':
                                        notification.Status('success', this, 'Slider taslağa kaldırıldı.');
                                        break;
                                    case '1':
                                        notification.Status('success', this, 'Slider başarıyla eklendi.');
                                        break;
                                    case '2':
                                        notification.Status('success', this, 'Slider arşive kaldırıldı.');
                                        break;
                                }
                                this.resetForm(formName);
                                this.sliderListe();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir slider zaten mevcut');

                            } else {
                                notification.Status(response.status, this);
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.imageListMain = [];
                this.visibleUstSayfa = false;
            },
        }
    }

</script>

<style lang="scss" scoped>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .yanForm .card {
        margin-top: 10px;
    }
</style>